import OnCallActions from './OnCallActions';

export default OnCallActions;
